import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSchedulerUsersReducer = () => useSelector((state: ApplicationState) => state.schedulerUsers);
